/**
 * 格式化富文本内容 -> 图片
 * @params rich_text 富文本原始内容
 * @return rich_text 格式化后的内容
 * @author BJ
 */
export function format_richtext__img(rich_text) {
	let reg = /<img.+?>/gim;
	let tem = [];
	while (tem = reg.exec(rich_text)) {
		let img_text = tem[0];
		// 设置 width=100%
		if (img_text.indexOf('width="100%"') === -1) {
			let new_img_text = img_text.substr(0, img_text.length - 1) + ' width="100%">';
			rich_text = rich_text.replace(img_text, new_img_text);
			img_text = new_img_text;
		}
		// 设置 display: block
		if (img_text.indexOf('style="') === -1) {
			let new_img_text = img_text.substr(0, img_text.length - 1) + ' style="display: block;">';
			rich_text = rich_text.replace(img_text, new_img_text);
			img_text = new_img_text;
		}
	}
	return rich_text;
}


/**
 * 格式化富文本内容 -> 去除首尾换行、空格
 * @params rich_text 富文本原始内容
 * @return rich_text 格式化后的内容
 * @author BJ
 */
export function format_richtext__trim(rich_text) {
	let reg = /<p><br><\/p>/gim;
	let t = [];
	let arr = [];
	while (t = reg.exec(rich_text)) {
		arr.push(t.index)
	}
	let m = 11;
	let start = 0;
	let end = rich_text.length;
	for (var n = 0; n < arr.length; n++) {
		if (arr[n] != n * m) break;
		start = (n + 1) * m;
	}
	for (var n = arr.length; n > 0; n--) {
		if (arr[n - 1] != rich_text.length - ((arr.length - (n - 1)) * m)) break;
		end = arr[n - 1];
	}
	return rich_text.slice(start, end);
}